export const CONSTANTS = {
  years: [
    { value: 'Never, New Cisco Partner', viewValue: 'Never, New Cisco Partner' },
    { value: 'Less than a Year', viewValue: 'Less than a Year' },
    { value: '1-3 years', viewValue: '1-3 years' },
    { value: '3-5 years', viewValue: '3-5 years' },
    { value: '5 or more years', viewValue: '5 or more years' }
  ],
  korean_years: [
    { value: '새로운 시스코 파트너', viewValue: '새로운 시스코 파트너' },
    { value: '1 년 미만', viewValue: '1 년 미만' },
    { value: '1-3 연령', viewValue: '1-3 연령' },
    { value: '3-5 연령', viewValue: '3-5 연령' },
    { value: '5 또는 몇 년', viewValue: '5 또는 몇 년' }
  ],
  japanese_years: [
    { value: '決して、新しいシスコパートナー', viewValue: '経験なし' },
    { value: '1年未満', viewValue: '1年未満' },
    { value: '1-3 年', viewValue: '1年以上3年未満' },
    { value: '3-5 年', viewValue: '3年以上5年未満' },
    { value: '5 以上の年', viewValue: '5年以上' }
  ],
  manager: ['PRACTICE_MANAGER', 'SALES_MANAGER', 'COMPANY_ADMIN'],
  salesManager: 'SALES_MANAGER',
  practiceLead: 'PRACTICE_MANAGER',
  seller: ['SALES_ENGINEER', 'ACCT_MANAGER', 'SE_MANAGER'],
  admin: ['COMPANY_ADMIN'],
  ciscoAdmin:['CISCO_ADMIN'],
  approver:['AC_APPROVER'],
  ciscoTitle: 'Seller Rewards',
  allActivities: ['Create Activity Challenges', 'Manage Challenges'],
  months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  oipType: [
    { type: 'FIRST_OF_THE_QUARTER', name: 'Complete first OIP', isMultiple: false },
    { type: 'MULTIPLE', name: 'Complete multiple OIPs', isMultiple: true },
  ],
  oipStatus: [
    { type: 'REGISTERED', name: 'Registered' },
    { type: 'BOOKED', name: 'Booked' },
  ],
  companyTypePreferences: [
    {
      id: 1,
      name: 'COMPANY_SALES_INCENTIVES', displayName: 'Sales Challenges',
      enabled: false,
      content: 'Participants earn points that can be redeemed in the rewards catalog for selling eligible products, software and services.'
    },
    {
      id: 2,
      name: 'COMPANY_ENABLEMENT_INCENTIVES',
      displayName: 'Activity Challenges', enabled: false,
      content: 'Participants earn tickets that can be redeemed for contest entries when they successfully complete trainings and other challenges.'
    },
    {
      id: 3,
      name: 'COMPANY_SELLER_GENERAL_LEADERBOARD',
      displayName: 'Leaderboards',
      enabled: false,
      content: 'Participants are able to view their rankings among their peers as they participate in common sales and activity challenges.'
    }
  ],


  korean_companyTypePreferences: [
    {
      id: 1,
      name: 'COMPANY_SALES_INCENTIVES', displayName: '판매 챌린지',
      enabled: false,
      content: '참가자는 대상 제품, 소프트웨어 및 서비스를 판매하기 위해 리워드 카탈로그에서 사용할 수 있는 포인트를 적립합니다. '
    },
    {
      id: 2,
      name: 'COMPANY_ENABLEMENT_INCENTIVES',
      displayName: '활동 챌린지', enabled: false,
      content: '참가자는 교육 및 기타 챌린지를 성공적으로 완료하면 콘테스트 응모로 교환할 수 있는 티켓을 획득합니다.'
    },
    {
      id: 3,
      name: 'COMPANY_SELLER_GENERAL_LEADERBOARD',
      displayName: '리더 보드',
      enabled: false,
      content: '참가자들은 일반적인 영업 및 활동 과제에 참여하면서 동료들 사이에서 자신의 순위를 볼 수 있습니다.'
    }
  ],


  japanese_companyTypePreferences: [
    {
      id: 1,
      name: 'COMPANY_SALES_INCENTIVES', displayName: 'セールスチャレンジ',
      enabled: false,
      content: '参加者は、対象となる製品やサービスを販売すると、特典カタログで引き換えることができるポイントが獲得できます。'
    },
    {
      id: 2,
      name: 'COMPANY_ENABLEMENT_INCENTIVES',
      displayName: 'アクティビティチャレンジ', enabled: false,
      content: '参加者は、トレーニングや他のチャレンジを達成すると、抽選に参加するときに引き換えられるチケットが獲得できます。'
    },
    {
      id: 3,
      name: 'COMPANY_SELLER_GENERAL_LEADERBOARD',
      displayName: 'リーダーボード（順位表）',
      enabled: false,
      content: '参加者は、共通のセールスチャレンジやアクティビティチャレンジに参加することで、同僚の間でのランキングを見ることができます。'
    }
  ],





  companyClaimingTypePreferences: [
    { id: 4, name: 'COMPANY_CLAIMING_QUICK', displayName: 'Quick Claiming', enabled: false },
    { id: 5, name: 'COMPANY_CLAIMING_PO_NUMBER', displayName: 'Claim By PO Number', enabled: false }
  ],
  sellerTypePreferences: [
    { id: 6, name: 'SELLER_SALES_INCENTIVES', enabled: false },
    { id: 7, name: 'SELLER_ENABLEMENT_INCENTIVES', enabled: false }
  ],
  errMessages: {
    'offerId': [
      { type: 'required', message: 'Offer Required' }
    ],
    'poNumber': [
      { type: 'required', message: 'PO Number Required' },
      { type: 'pattern', message: 'Please Enter Valid PO Number' }

    ]
  },

  korean_errMessages: {
    'offerId': [
      { type: 'required', message: '제안 필요' }
    ],
    'poNumber': [
      { type: 'required', message: 'PO 번호 필요' },
      { type: 'pattern', message: '유효한 PO 번호를 입력하십시오' }

    ]
  },

  japanese_errMessages: {
    'offerId': [
      { type: 'required', message: 'オファーが必要です' }
    ],
    'poNumber': [
      { type: 'required', message: 'PO番号が必要です' },
      { type: 'pattern', message: '有効なPO番号を入力してください' }

    ]
  },
  regex: {
    numeric: '[0-9 ]*',
    alpha: '^[a-zA-Z \-\']+',
    alphaNumeric: '^[a-zA-Z0-9]*$',
    email: '^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$',
    sin: '^[0-9]{3}\-?[0-9]{3}\-?[0-9]{3}$',
    ssn: '^[0-9]{3}\-[0-9]{2}\-[0-9]{4}$',
    itin: '^[0-9]{3}\-[0-9]{2}\-[0-9]{4}$',
    ein: '^[0-9]{2}\-[0-9]{7}$',
    zipcode: '^[0-9 ]{5,}$',
    notZero: '^[1-9][0-9]*$',
    alphaWithComma: '^[A-Za-z, ]+$',

  },

  validationMessages: {
    login: {
      'username': [
        { type: 'required', message: 'Mandatory Field' },
        { type: 'minlength', message: 'Incorrect CCOID' },
        { type: 'maxlength', message: 'Incorrect CCOID' },
        { type: 'pattern', message: 'Please Enter Valid CCOID' }
      ],
      'password': [
        { type: 'required', message: 'Mandatory Field' },
        { type: 'minlength', message: 'Incorrect password.' },
        { type: 'maxlength', message: 'Incorrect password.' }
      ]
    },
    formT4: {
      'firstName': [
        { type: 'required', message: 'First Name Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'middleName': [
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'lastName': [
        { type: 'required', message: 'Last Name Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'exemptPayeeCode': [
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'address': [
        { type: 'required', message: 'Address Required' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'city': [
        { type: 'required', message: 'City Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'state': [
        { type: 'required', message: 'State Required' }
      ],
      'zipCode': [
        { type: 'required', message: 'Zip code Required' },
        { type: 'maxlength', message: 'Zip Code Limit is 6' },
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'sin': [
        { type: 'required', message: 'SIN Required' },
        { type: 'pattern', message: 'Please Enter Valid SIN' }
      ],
      'confirmSin': [
        { type: 'required', message: 'SIN Required' },
        { type: 'notEqual', message: 'SIN Mismatched' }
      ],
      'signature': [
        { type: 'required', message: 'Signature Required' },
        { type: 'maxlength', message: 'Limit Exceeded' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ]
    },
    formW9: {
      'firstName': [
        { type: 'required', message: 'First Name Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'middleName': [
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'lastName': [
        { type: 'required', message: 'Last Name Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'businessName': [
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'exemptPayeeCode': [
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'fatcaReportingCode': [
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'address': [
        { type: 'required', message: 'Address Required' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'city': [
        { type: 'required', message: 'City Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'state': [
        { type: 'required', message: 'State Required' }
      ],
      'zipCode': [
        { type: 'required', message: 'Zip code Required' },
        { type: 'maxlength', message: 'Zip Code Limit is 5' },
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'accountNumbers': [
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'ssn': [
        { type: 'required', message: 'SSN Required' },
        { type: 'pattern', message: 'Please Enter Valid SSN code' }
      ],
      'confirmSsn': [
        { type: 'required', message: 'SSN Required' },
        { type: 'notEqual', message: 'SSN Mismatched' }
      ],
      'ein': [
        { type: 'required', message: 'EIN Required' },
        { type: 'pattern', message: 'Please Enter Valid EIN code' }
      ],
      'confirmEin': [
        { type: 'required', message: 'EIN Required' },
        { type: 'notEqual', message: 'EIN Mismatched' }
      ],
      'signature': [
        { type: 'required', message: 'Signature Required' },
        { type: 'maxlength', message: 'Limit Exceeded' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ]
    },
    wben: {
      'name': [
        { type: 'required', message: 'Full name Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'countryOfCitizenship': [
        { type: 'required', message: 'Country Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'address': [
        { type: 'required', message: 'Address Required' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'city': [
        { type: 'required', message: 'City Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'state': [
        { type: 'required', message: 'State Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' },
      ],
      'zipCode': [
        { type: 'required', message: 'Postal code Required' },
        { type: 'maxlength', message: 'Postal Code Limit is 5' },
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'country': [
        { type: 'required', message: 'Country Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'mailingAddress': [
        { type: 'required', message: 'Mailing Address Required' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'mailingCity': [
        { type: 'required', message: 'Mailing City Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'mailingState': [
        { type: 'required', message: 'Mailing State Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'mailingZipCode': [
        { type: 'required', message: 'Mailing Postal Required' },
        { type: 'maxlength', message: 'Postal Code Limit is 5' },
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'mailingCountry': [
        { type: 'required', message: 'Mailing Country Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'ssn': [
        { type: 'pattern', message: 'Please Enter Valid SSN code' }
      ],
      'itin': [
        { type: 'pattern', message: 'Please Enter Valid ITIN code' }
      ],
      'foreignTaxIdentificationNumber': [
        { type: 'required', message: 'TIN Required' },
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'referenceNumbers': [
        { type: 'required', message: 'Reference Number Required' },
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'dateOfBirth': [
        { type: 'required', message: 'Date of Birth Required' },
      ],
      'taxTreatyCountry': [
        { type: 'required', message: 'Country Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'treatyParagraph': [
        { type: 'required', message: 'Article and Paragraph Required' },
      ],
      'claimPercentageRate': [
        { type: 'required', message: 'Percentage Required' },
        { type: 'pattern', message: 'Please Enter Numbers Only' }
      ],
      'typeOfIncome': [
        { type: 'required', message: 'Type of Income Required' },
      ],
      'additionalConditions': [
        { type: 'required', message: 'Additional Conditions Required' },
      ],
      'signature': [
        { type: 'required', message: 'Signature Required' },
        { type: 'maxlength', message: 'Limit Exceeded' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'nameOfSigner': [
        { type: 'required', message: 'Name Required' },
        { type: 'pattern', message: 'Please Enter Characters Only' }
      ],
      'capacityInWhichActing': [
        { type: 'required', message: 'Signature Required' },
      ],
    },
    manageActivity: {
      'challengeType': [
        { type: 'required', message: 'This is a required field' }
      ],
      'startDate': [
        { type: 'required', message: 'This is a required field' }
      ],
      'completeBy': [
        { type: 'required', message: 'This is a required field' },
        { type: 'matDatepickerMin', message: 'End Date cannot be less than Start Date' },
        { type: 'matDatepickerMax', message: 'This date is not valid for this quarter' }
      ],
      'credits': [
        { type: 'required', message: 'This is a required field' },
        { type: 'pattern', message: 'Please enter whole number amounts only' }
      ],
      'bookingsToBeSold': [
        { type: 'required', message: 'This is a required field' },
        { type: 'pattern', message: 'Please Enter Valid Amount' }
      ],
      'architectureBookingsToBeSold': [
        { type: 'required', message: 'This is a required field' },
        { type: 'pattern', message: 'Please Enter Valid Amount' }
      ],
      'numberOfOipsToComplete': [
        { type: 'required', message: 'This is a required field' },
        { type: 'pattern', message: 'Please Enter Numbers Only' },
        { type: 'max', message: 'Maximum Limit for OIPs is 10' }
      ],
      'winnersCount': [
        { type: 'required', message: 'This is a required field' }
      ],
      'name': [
        { type: 'required', message: 'This is a required field' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
    },

    korean_manageActivity: {
      'challengeType': [
        { type: 'required', message: '챌린지 유형 필요' }
      ],
      'startDate': [
        { type: 'required', message: '시작 날짜 필요' }
      ],
      'completeBy': [
        { type: 'required', message: '종료 날짜 필요' },
        { type: 'matDatepickerMin', message: '종료 날짜는 시작 날짜보다 이전일 수 없습니다.' },
        { type: 'matDatepickerMax', message: '이 날짜는 이번 분기에 유효하지 않습니다' }
      ],
      'credits': [
        { type: 'required', message: '티켓 필요' },
        { type: 'pattern', message: '정수 금액만 입력하십시오' }
      ],
      'bookingsToBeSold': [
        { type: 'required', message: '예약 필요' },
        { type: 'pattern', message: '유효한 금액을 입력하십시오' }
      ],
      'architectureBookingsToBeSold': [
        { type: 'required', message: '예약 필요' },
        { type: 'pattern', message: '유효한 금액을 입력하십시오' }
      ],
      'numberOfOipsToComplete': [
        { type: 'required', message: '적격 OIP 필요' },
        { type: 'pattern', message: '숫자만 입력하십시오' },
        { type: 'max', message: 'OIP의 최대 한도는 10' }
      ],
      'winnersCount': [
        { type: 'required', message: '우승자 수 필요' }
      ],
      'name': [
        { type: 'required', message: '과제 이름 필요' },
        { type: 'maxlength', message: '제한된 수가 초과됨' }
      ],
    },

    japanese_manageActivity: {
      'challengeType': [
        { type: 'required', message: 'チャレンジのタイプが必要です' }
      ],
      'startDate': [
        { type: 'required', message: '開始日が必要です' }
      ],
      'completeBy': [
        { type: 'required', message: '終了日が必要です' },
        { type: 'matDatepickerMin', message: '終了日は開始日より前になることはできません' },
        { type: 'matDatepickerMax', message: 'この四半期にこの日付はありません' }
      ],
      'credits': [
        { type: 'required', message: 'チケットが必要です' },
        { type: 'pattern', message: '整数のみで入力して下さい' }
      ],
      'bookingsToBeSold': [
        { type: 'required', message: '予約取引が必要です' },
        { type: 'pattern', message: '有効な額を入力して下さい' }
      ],
      'architectureBookingsToBeSold': [
        { type: 'required', message: '予約取引が必要です' },
        { type: 'pattern', message: '有効な額を入力して下さい' }
      ],
      'numberOfOipsToComplete': [
        { type: 'required', message: '対象となるOIPが必要です' },
        { type: 'pattern', message: '数字だけ入力してください' },
        { type: 'max', message: 'OIPは最大10までです' }
      ],
      'winnersCount': [
        { type: 'required', message: '当選者数が必要です' }
      ],
      'name': [
        { type: 'required', message: 'チャレンジ名が必要です' },
        { type: 'maxlength', message: '制限を超えています' }
      ],
    },
    supportForm: {
      'ticketCategory': [
        { type: 'required', message: 'Inquiry Topic Required' },
      ],
      'subject': [
        { type: 'required', message: 'Subject Required' },
        { type: 'maxlength', message: 'Limit Exceeded' }
      ],
      'description': [
        { type: 'required', message: 'Description Required' },
      ],
      'requestorEmail': [
        { type: 'required', message: 'Email Required' },
        { type: 'email', message: 'Please Enter Valid Email' }
      ],
      'region':[{
        type:'required',message:'Region Required'
      }]
    },

    korean_supportForm: {
      'ticketCategory': [
        { type: 'required', message: '질문의주제가필요합니다.' },
      ],
      'subject': [
        { type: 'required', message: '주제가필요합니다.' },
        { type: 'maxlength', message: '제한된 수가 초과됨' }
      ],
      'description': [
        { type: 'required', message: '상세설명이필요합니다.' },
      ],
      'requestorEmail': [
        { type: 'required', message: '이메일 필수' },
        { type: 'email', message: '유효한 이메일을 입력하십시오' }
      ],'region':[{
        type:'required',message:'지역을 기입해주세요.'
      }]
    },

    japanese_supportForm: {
      'ticketCategory': [
        { type: 'required', message: '問い合わせのトピックが必要です' },
      ],
      'subject': [
        { type: 'required', message: '必要な科目' },
        { type: 'maxlength', message: '制限を超えています' }
      ],
      'description': [
        { type: 'required', message: '内容が必要です' },
      ],
      'requestorEmail': [
        { type: 'required', message: 'メールが必要です' },
        { type: 'email', message: '有効なメールアドレスを入力して下さい' }
      ],'region':[{
        type:'required',message:'地域入力必須'
      }]
    }
  },
  canadaStates: [
    { value: 'Alberta', viewValue: 'Alberta' },
    { value: 'British', viewValue: 'British Columbia' },
    { value: 'Manitoba', viewValue: 'Manitoba' },
    { value: 'New Brunswick', viewValue: 'New Brunswick' },
    { value: 'Newfoundland', viewValue: 'Newfoundland And Labrador' },
    { value: 'Northwest Territories', viewValue: 'Northwest Territories' },
    { value: 'Nova Scotia', viewValue: 'Nova Scotia' },
    { value: 'Nunavut', viewValue: 'Nunavut' },
    { value: 'Ontario', viewValue: 'Ontario' },
    { value: 'Prince', viewValue: ' Prince Edward Island' },
    { value: 'Quebec', viewValue: 'Quebec' },
    { value: 'Saskatchewan', viewValue: 'Saskatchewan' },
    { value: 'Yukon', viewValue: 'Yukon' },
  ],
  americaStates: [
    { value: 'Alabama', viewValue: 'Alabama' },
    { value: 'Alaska', viewValue: 'Alaska' },
    { value: 'Arizona', viewValue: 'Arizona' },
    { value: 'Arkansas', viewValue: 'Arkansas' },
    { value: 'California', viewValue: 'California' },
    { value: 'Colorado', viewValue: 'Colorado' },
    { value: 'Connecticut', viewValue: 'Connecticut' },
    { value: 'Delaware', viewValue: 'Delaware' },
    { value: 'Florida', viewValue: 'Florida' },
    { value: 'Georgia', viewValue: 'Georgia' },
    { value: 'Hawaii', viewValue: 'Hawaii' },
    { value: 'Idaho', viewValue: 'Idaho' },
    { value: 'Illinois', viewValue: 'Illinois' },
    { value: 'Indiana', viewValue: 'Indiana' },
    { value: 'Iowa', viewValue: 'Iowa' },
    { value: 'Kansas', viewValue: 'Kansas' },
    { value: 'Kentucky', viewValue: 'Kentucky' },
    { value: 'Louisiana', viewValue: 'Louisiana' },
    { value: 'Maine', viewValue: 'Maine' },
    { value: 'Maryland', viewValue: 'Maryland' },
    { value: 'Massachusetts', viewValue: 'Massachusetts' },
    { value: 'Michigan', viewValue: 'Michigan' },
    { value: 'Minnesota', viewValue: 'Minnesota' },
    { value: 'Mississippi', viewValue: 'Mississippi' },
    { value: 'Missouri', viewValue: 'Missouri' },
    { value: 'Montana', viewValue: 'Montana' },
    { value: 'Nebraska', viewValue: 'Nebraska' },
    { value: 'Nevada', viewValue: 'Nevada' },
    { value: 'New Hampshire', viewValue: 'New Hampshire' },
    { value: 'New Jersey', viewValue: 'New Jersey' },
    { value: 'New Mexico', viewValue: 'New Mexico' },
    { value: 'New York', viewValue: 'New York' },
    { value: 'North Carolina', viewValue: 'North Carolina' },
    { value: 'Verth Dakota', viewValue: 'North Dakota' },
    { value: 'Norgon', viewValue: 'Oregon' },
    { value: 'Ohio', viewValue: 'Ohio' },
    { value: 'Oklahoma', viewValue: 'Oklahoma' },
    { value: 'Pennsylvania', viewValue: 'Pennsylvania' },
    { value: 'Rhode Island	', viewValue: 'Rhode Island	' },
    { value: 'South Carolina', viewValue: 'South Carolina' },
    { value: 'South Dakota', viewValue: 'South Dakota' },
    { value: 'Tennessee', viewValue: 'Tennessee' },
    { value: 'Texas', viewValue: 'Texas' },
    { value: 'Utah', viewValue: 'Utah' },
    { value: 'Oremont', viewValue: 'Vermont' },
    { value: 'Virginia', viewValue: 'Virginia' },
    { value: 'Washington', viewValue: 'Washington' },
    { value: 'West Virginia', viewValue: 'West Virginia' },
    { value: 'Wisconsin', viewValue: 'Wisconsin' },
    { value: 'Wyoming', viewValue: 'Wyoming' }
  ],
  userPreferences: [
    {
      id: 6,
      name: 'SELLER_SALES_INCENTIVES'
    },
    {
      id: 7,
      name: 'SELLER_ENABLEMENT_INCENTIVES'
    },
    {
      id: 10,
      name: 'SELLER_OPT_OUT_OF_LEADERBOARD'
    }
  ],
  activityChallengesSubTabs: [
    {
      id: 1,
      name: 'Partner Assigned Activity Challenges',
      description: 'Partner Assigned Activity Challenges are specifically created for and assigned to you by your company. Successful completion of this type of Activity Challenge earns Rewards Tickets that can be redeemed for entries into our quarterly contest prize drawings.',
    },
    {
      id: 2,
      name: 'Cisco General Activity Challenges',
      description: 'Cisco General Activity Challenges are created by Cisco and generally eligible for all Seller Rewards participants. Successful completion of this type of Activity Challenge earns Rewards Tickets that can be redeemed for entries into our quarterly contest prize drawings.',
    },
    {
      id: 3,
      name: 'Cisco Special Activity Challenges',
      description: 'Cisco Special Activity Challenges are created by Cisco with specific eligibility requirements to participate. Successful completion of this type of Activity Challenge earns Rewards Tickets and/or Rewards Points. Download and review each Activity Challenge terms and conditions for eligibility requirements and rewards earnings.',
    },
    // {
    //   id: 4,
    //   name: 'Create Activity Challenges',
    //   description: 'Select, assign, and create activity challenges.',
    // }
  ],
  korean_activityChallengesSubTabs: [
    {
      id: 1,
      name: '할당된 과제',
      description: '성공적으로 완료시 티켓으로 보상드리기 위해 귀하 회사에만 과제가 부여되었습니다. SaleConnect 의 모든 교육 내용들은 고객님 국가의 언어로 제공되지 않을 수 있음을 알려드립니다.',
    },
    {
      id: 2,
      name: '일반적인 과제',
      description: '이러한 활동 챌린지는 Cisco에 의해 만들어졌으며 일반적으로 모든 사용자가 참여하고 보상 티켓을 적립할 수 있습니다.',
    },
    {
      id: 3,
      name: '특별한 도전',
      description: '이러한 특별 활동 과제는 Cisco에서 매우 구체적인 대상 및 활동을 위해 만들었습니다. 여기에는 챌린지 이용 약관 및 성공적인 완료를 위한 보상 포인트가 포함됩니다.',
    }
    // {
    //   id: 4,
    //   name: '활동 과제 만들기',
    //   description: '활동 과제를 선택, 할당 및 생성합니다.',
    // }
  ],
  japanese_activityChallengesSubTabs: [
    {
      id: 1,
      name: 'Assigned Challenges',
      description: '割り当てられたチャレンジは、所属する会社が作成したものであり、達成すると特典チケットが獲得できます。セールスコネクトについての全てのトレーニング資料が、各地域の言語で入手可能とは限りませんので、ご了承下さい。',
    },
    {
      id: 2,
      name: 'General Challenges',
      description: 'これらのアクティビティチャレンジは、シスコにより作成されたものです。通常、全ての販売者が参加することができ、特典チケットが獲得できます。',
    },
    {
      id: 3,
      name: 'Special Challenges',
      description: 'これらの「スペシャル」アクティビティチャレンジは、特定の参加者とアクティビティのためにシスコにより作成されたものです。チャレンジの規約が含まれています。また、達成すると特典ポイントが獲得できます。',
    }
    // {
    //   id: 4,
    //   name: 'アクティビティチャレンジの作成',
    //   description: 'アクティビティチャレンジの選択、割り当て及び作成',
    // }
  ],
  KEYS: {
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    ACCESS_TOKEN_EXPIRY: 'ACCESS_TOKEN_EXPIRY',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    REFRESH_TOKEN_EXPIRY: 'REFRESH_TOKEN_EXPIRY',
    ID_TOKEN: 'ID_TOKEN',
    ID_TOKEN_EXPIRY: 'ID_TOKEN_EXPIRY',
    USER_DATA: 'USER_DATA',
    CODE_VERIFIER: 'CODE_VERIFIER',
    USER_PROFILE: 'userProfile',
    OIDC_STATE: 'OIDC_STATE',
    RETURN_URL: 'RETURN_URL'
  }
};
